<template>
  <m-card207
      :image="product.thumbnail"
      :alt="product.name"
      class="product-card-207 "
  >
    <template #p-1>
      <p class="p-0 m-0">{{ contentSlicer(product.name, 55) }}</p>

    </template>
    <template #p-2>

      <div class="col-12 price-card-title pb-2 px-0">
        <template v-if="product.variation == 1" v-for="feature in productFeatureSubProduct(product)">
          <ProductCard502PriceManager class="product-card-200-price-manager-wrapper px-1"
                                      show-trash-only-in-first-quantity="true"
                                      :product="product"
                                      :feature="feature"/>
        </template>
        <ProductCard502PriceManager show-trash-only-in-first-quantity="true"
                                    class="product-card-200-price-manager-wrapper px-1" v-else :product="product"/>
      </div>

    </template>

    <template #p-3>
      <div class=""></div>
    </template>
  </m-card207>
</template>

<script>
import {shoppingCartFunctions} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions";
import mCard207 from "../../../Cards/Card207";
import mA from "../../../Tags/A";
import mProductCardQuantityManager1 from "../../QuantityManager/Card/ProductCardQuantityManager1";
import mProductPrice200 from "../../ProductPrice200";
import mProductOffer1 from "../../ProductOffer/ProductOffer1";
import {OfferProps} from "../../ProductOffer/ProductOfferProps";
import {
  addFeatureToProduct,
  featureCategories,
  findFeatureWithSelectedName,
  groupByType, productFeatureName, productFeatureSubProduct,
  productFeatureValue,
  removeChildFeature,
  removeEmptyGroups,
  sortedFeaturesMethod,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {contentSlicer} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/ContentFunctions";
import ProductCard502PriceManager from "../ProductCard502Quantity/ProductCard502PriceManager.vue";


export default {
  name: "ProductCard502",
  components: {
    mCard207,
    mA,
    mProductCardQuantityManager1,
    mProductPrice200,
    mProductOffer1,
    ProductCard502PriceManager,
  },

  props: {
    product: {},
    ...OfferProps,
  },
  methods: {
    contentSlicer,
    ...shoppingCartFunctions,
    findFeatureWithSelectedName,
    productFeatureName,
    productFeatureSubProduct,
    selectVariation(product, feature) {
      this.selectedVariation = feature.id
      this.selectedVariationObject = feature
    }
  }
}
</script>

<style scoped>
.product-card-207 {
  height: fit-content;
}

.card207-icon {
  width: 36px;
  height: 32px;
  object-fit: cover;
  border-radius: 7px;
}


</style>
